// @flow


import type {SessionState} from '../types'
import type {SetReadyPayload} from '../actions/setReady'

export function setReadyReducer(state: SessionState, action: Action<SetReadyPayload>): SessionState {

  return {
    ...state,
    isReady: true,
  }
}
